import React, { Component } from 'react';
import PropTypes from 'prop-types';

const { __ } = window.wp.i18n;

class LocalCountryPage extends Component {
  state = {
    local_country_pages_list: [
      { key: 'United Kingdom', value: '/gb-en/careers/join-us/' },
      { key: 'France', value: '/fr-fr/carrieres/nous-rejoindre/' },
      { key: 'Austria', value: '/at-de/karriere/jobs/' },
      { key: 'Germany', value: '/de-de/karriere/jobs/' },
      { key: 'Denmark', value: '/dk-en/careers/join-us/' },
      { key: 'Argentina', value: '/ar-es/careers/join-us/' },
      { key: 'Australia', value: '/au-en/careers/join-us/' },
      { key: 'Belgium', value: '/be-en/careers/join-us/' },
      { key: 'Italy', value: '/it-it/carriere/lavora-con-noi/' },
      { key: 'Spain', value: '/es-es/talento/trabaja-en-capgemini/busqueda-de-empleo/' },
      { key: 'Sweden', value: '/se-en/careers/join-us/' },
      { key: 'Canada', value: '/ca-fr/carrieres/nous-rejoindre/' },
      { key: 'Japan', value: '/jp-jp/join-us/' },
      { key: 'Norway', value: '/no-no/careers/join-us/' },
      { key: 'Switzerland', value: '/ch-en/careers/join-capgemini/job-search/' },
      { key: 'Colombia', value: '/co-es/careers/join-us/' },
      { key: 'Finland', value: '/fi-en/careers/join-us/' },
      { key: 'Poland', value: '/pl-pl/careers/join-us/' },
      { key: 'Mexico', value: '/mx-es/careers/join-us/' },
      { key: 'Portugal', value: '/pt-en/careers/join-capgemini/job-search/' },
      { key: 'India', value: '/in-en/careers/join-us/' },
      { key: 'United States', value: '/us-en/join-us/' },
      { key: 'Czech Republic', value: '/cz-en/join-us/' },
      { key: 'Hungary', value: '/hu-en/join-us/' },
      { key: 'Singapore', value: '/sg-en/join-us/' },
      { key: 'Romania', value: '/ro-en/join-us/' },
      { key: 'New Zealand', value: '/nz-en/join-us/' },
      { key: 'Egypt', value: '/eg-en/jobs/' },
      { key: 'Guatemala', value: 'gu-en/join-us/' },
      { key: 'Brazil', value: '/br-pt/carreira/busca-de-vagas/' }
    ]
  };

  render () {
    const country = this.props.countryName;
    const keyword = this.props.keyword;
    let localCountryLink = '';
    try {
      localCountryLink = this.state.local_country_pages_list.find(function (o) { return o.key === country; })?.value;
      if (keyword !== '') {
        localCountryLink = localCountryLink.concat('#keyword=').concat(keyword);
      }
    } catch (e) {}

    return (
      localCountryLink &&
            <div className="local-country-link">
                <h4>{ __('To refine your search in this country, you can visit ', 'macs-react-jobs') }
                    <a href={localCountryLink}>{ __('the local page', 'macs-react-jobs') }</a>
                </h4>
            </div>
    );
  }
}

export default LocalCountryPage;

LocalCountryPage.propTypes = {
  countryName: PropTypes.string,
  keyword: PropTypes.string
};
